import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=07774e8e&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('07774e8e', component.options)
    } else {
      api.reload('07774e8e', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=07774e8e&", function () {
      api.rerender('07774e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/ColorPicker.vue"
export default component.exports